import { Paid } from '@mui/icons-material';
import {
  IDeletePatient,
  IPublicButton,
  IUpdatePatient,
  ICreatePatient,
} from './type';
import { formatToRequestParameter } from 'utils/formatting';

import apiGateway from './apiGateway';
import {
  IGetAdminPatients,
  IGetPatient,
  IGetPatientName,
  IGetAccountsPatient,
} from './type';

export const getAccountsPatient = (request: IGetAccountsPatient) => {
  const keyword = request.keyword ? request.keyword : '';
  const searchType = request.searchType ? Number(request.searchType) : 2;

  const baseUrl = () => {
    return '/main/admin/patientSearch';
  };
  const url = `${baseUrl()}?size=20&${formatToRequestParameter({
    ...request,
    keyword,
    searchType,
  })}`;
  return apiGateway.get(url);
};

export const getAdminPatients = (request: IGetAdminPatients) => {
  const url = `/admin/patients?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const postCreatePatient = (request: ICreatePatient) => {
  const url = `/admin/patient/create`;
  return apiGateway.post(url, request);
};

export const getPatient = ({ patientId, collegeId }: IGetPatient) => {
  const url = `/admin/patient?patient_id=${patientId}&college_id=${collegeId}`;
  return apiGateway.get(url);
};

export const getPatientName = ({ name }: IGetPatientName) => {
  const url = `/admin/patients/name/search?keyword=${name}`;
  return apiGateway.get(url);
};

export const postUpdatePatient = (request: IUpdatePatient) => {
  const url = `/main/profs/patient_update`;
  return apiGateway.post(url, request);
};

export const postDeletePatient = (request: IDeletePatient) => {
  const url = `/admin/patient/delete?${formatToRequestParameter(request)}`;
  return apiGateway.post(url);
};

export const postPrivate = (request: IPublicButton) => {
  const url = `/admin/patient/set_private?setType=public&${formatToRequestParameter(
    request
  )}`;
  return apiGateway.get(url);
};

export const postPublic = (request: IPublicButton) => {
  const url = `/admin/patient/set_private?${formatToRequestParameter(request)}`;
  return apiGateway.get(url);
};

export const postAdminClearKey = () => {
  const url = '/admin/clearKey';
  return apiGateway.post(url, {});
};
